import { VersionSelectOption } from '@qality/common-components/src/select/VersionSelect';
import { Version } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';

const NOT_FOUND_CODE = 404;

export default {
  async getVersion(versionId: number | string): Promise<Version> {
    try {
      const response = await StorageOfUniqueServices.get('API').noRetry({
        url: `/rest/api/2/version/${versionId}`,
        type: 'GET',
      });
      return JSON.parse(response.body);
    } catch (e) {
      if (e.xhr?.status === NOT_FOUND_CODE) {
        return {} as Version;
      }
      throw new Error(`Could not fetch version with id ${versionId}!`);
    }
  },

  async getVersions(
    projectId: number | string
  ): Promise<Array<{ id: number; name: string }>> {
    const response = await StorageOfUniqueServices.get('API').request({
      url: `/rest/api/2/project/${projectId}/versions`,
      type: 'GET',
    });
    return JSON.parse(response.body);
  },

  async getVersionOptions(
    projectId: number | string
  ): Promise<Array<VersionSelectOption>> {
    const versions = await this.getVersions(projectId);
    const versionsOptions = versions.map((version) => {
      return {
        label: version.name,
        value: version.id,
      };
    });
    versionsOptions.unshift({
      label: 'No version',
      value: '-1',
    });
    return versionsOptions;
  },
};
